__turbopack_context__.v({
  "button": "button-module__IR35iW__button",
  "buttonFitWidth": "button-module__IR35iW__buttonFitWidth",
  "buttonFullWidth": "button-module__IR35iW__buttonFullWidth",
  "iconContainer": "button-module__IR35iW__iconContainer",
  "loadingSpinner": "button-module__IR35iW__loadingSpinner",
  "sizeIcon": "button-module__IR35iW__sizeIcon",
  "sizeLg": "button-module__IR35iW__sizeLg",
  "sizeMd": "button-module__IR35iW__sizeMd",
  "sizeSm": "button-module__IR35iW__sizeSm",
  "sizeXl": "button-module__IR35iW__sizeXl",
  "variantAccentBrand": "button-module__IR35iW__variantAccentBrand",
  "variantAccentBrandOutline": "button-module__IR35iW__variantAccentBrandOutline",
  "variantDefault": "button-module__IR35iW__variantDefault",
  "variantDestructive": "button-module__IR35iW__variantDestructive",
  "variantGhost": "button-module__IR35iW__variantGhost",
  "variantLink": "button-module__IR35iW__variantLink",
  "variantOutline": "button-module__IR35iW__variantOutline",
  "variantSecondary": "button-module__IR35iW__variantSecondary",
});
